import React, { Component } from 'react';

import PropTypes from 'prop-types';

import CanvasMenuButton from '../menu/CanvasMenuButton';

export default class CanvasTextFontStyle extends Component {
  static propTypes = {
    canvasRef: PropTypes.object,
    onUpdate: PropTypes.func,
    updateInfo: PropTypes.func,
    isAllItalic: PropTypes.bool
  };

  isItalic(item) {
    if ('fontStyle' in item) {
      return item.fontStyle.indexOf('italic') >= 0;
    }
    return false;
  }

  isNormalize(canvasRef) {
    let activeObjects = canvasRef.getActiveObjects();
    const isAllSeted = activeObjects.every(this.isItalic);
    const isAllNotSet = activeObjects.every((item) => !this.isItalic(item));
    const needNormalize =
      !isAllNotSet && !isAllSeted && activeObjects.length > 1;

    if (needNormalize) {
      activeObjects = activeObjects.filter((item) => this.isItalic(item));
    }

    return activeObjects;
  }

  toggleItalic() {
    const { canvasRef, onUpdate, updateInfo } = this.props;

    const activeObjects = this.isNormalize(canvasRef);

    activeObjects.forEach((item) => {
      if (this.isItalic(item)) {
        item.set({ fontStyle: '' });
      } else {
        item.set({ fontStyle: 'italic' });
      }
    });

    canvasRef.renderAll();

    onUpdate();
    updateInfo();
  }

  render() {
    const { isAllItalic } = this.props;

    return (
      <CanvasMenuButton
        onClick={this.toggleItalic.bind(this)}
        toolTip="canvas-editor.text.italic"
        icon="italic"
        active={isAllItalic}
      />
    );
  }
}
